module.exports = __webpack_public_path__ + "img/home_perview_title.d2650ff1.jpg";